<template>
    <div class="template-login-register">
        <header class="header-animation">
            <div class="top">
                <div class="container">
                    <a href="https://simoniot.com">
                        <img src="../../assets/img/logo-dark.png" alt="">
                    </a>

                    <RegisterLink :variant="'white'"></RegisterLink>
                </div>
            </div>

            <div class="lamp">
            </div>
            <div class="text">Shattering Expectations in Iot</div>

            <div class="particles">
                <vue-particles  color="#17F9F9" linesColor="#16F8F8" :particlesNumber="100"></vue-particles>
            </div>
        </header>

        <div class="contentpage">
            <div class="container-login">
                <h3>Set Password</h3>
                <h5>In order to use the portal, you need to set a new Password.</h5>
                <h4>Your password must have at least 8 characters and contain a mix of lower case and upper case letters, numbers and a special character ( e.g.!#&)</h4>

                <div class="form">
                    <fieldset>
                        <div class="password-input-box no-icon">
                            <div class="lock-box">
                                <i class="fa fa-lock"></i>
                            </div>
                            <div class="password-input">
                                <input type="password" name="oldPassword" id="oldPassword" ref="oldPassword" v-validate="{required: true}" placeholder="Old password" data-vv-as="password" v-model="password.old">
                            </div>
                        </div>
                        <span v-show="errors && errors.has('oldPassword')" class="validate-warning">Old password is required field.</span>
                    </fieldset>

                    <fieldset>
                        <div class="password-input-box">
                            <div class="lock-box">
                                <i class="fa fa-lock"></i>
                            </div>
                            <div class="password-input">
                                <input :type="pswdHidden.one ? 'password' : 'text'" name="password1" id="password1" ref="password1" v-validate="{required: true, regex: regexPassword, is_not: password.old}" placeholder="Enter password" data-vv-as="password" v-model="password.one">
                                <i :class="['fa', pswdHidden.one ? 'fa-eye' : 'fa-eye-slash']" @click="showPswd(1)"></i>
                            </div>
                        </div>
                        <span v-show="errors && errors.has('password1') && password.old != password.one" class="validate-warning">Password does not fullfill requirements.</span>
                        <span v-show="errors && errors.has('password1') && password.old == password.one" class="validate-warning">New password must be different than old one.</span>
                    </fieldset>

                    <fieldset>
                        <div class="password-input-box">
                            <div class="lock-box">
                                <i class="fa fa-lock"></i>
                            </div>
                            <div class="password-input">
                                <input :type="pswdHidden.two ? 'password' : 'text'" name="password2" id="password2" v-model="password.two" v-validate="{required: true, confirmed: 'password1', regex: regexPassword}" placeholder="Confirm password" data-vv-as="password">
                                <i :class="['fa', pswdHidden.two ? 'fa-eye' : 'fa-eye-slash']" @click="showPswd(2)"></i>
                            </div>
                        </div>
                        <span v-show="errors && errors.has('password2')" class="validate-warning reset-password-error">{{ errors.first('password2') }}</span>
                    </fieldset>

                    <button type="submit" v-on:click.prevent="setPassword" class="btn btn-sumbit">Set password</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Axios from "axios";
    import globalStore from "../../variables";
    import VeeValidate from 'vee-validate';
    import RegisterLink from "@/views/RegisterLink";

    const veeValidateConfig = {};

    Vue.use(VeeValidate, veeValidateConfig);

    export default {
        name: "SetPassword",
        components: {
            RegisterLink
        },
        data() {
            return {
                regexPassword: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\ \!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@\[\\\]\^\_\`\{\|\}\~]).{8,}$/,
                password: {
                    old: null,
                    one: null,
                    two: null
                },
                pswdHidden: {
                    one: true,
                    two: true
                },
                username: ''
            }
        },
        methods: {
            setPassword() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        let data = {
                            userName: this.username,
                            currentPassword: this.password.old,
                            newPassword: this.password.one
                        }
                        Axios.post(globalStore.data.restApiUrl + '/register/required-password-reset', data)
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Set password done',
                                    text: 'Now you can login with new password.',
                                    duration: 5000,
                                });
                                this.$router.push('/login')
                            })
                            .catch(error => {
                                if (error.response && error.response.data && error.response.data.errors[0].errorCode == 'BadApiRequestException' &&  error.response.data.errors[0].errorMessage == 'Wrong password') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Incorrect password error',
                                        text: 'You passed incorrect password. Please check your old password.',
                                        duration: 5000,
                                    });
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Set password error',
                                        text: 'An error has occured during setting password, please contact support.',
                                        duration: 5000,
                                    });
                                }
                                console.log(error)
                            })
                        console.log('set pswd')
                    } else {
                        console.log('no set pswd')
                    }
                })
            },
            showPswd(pswd) {
                if (pswd == 1) {
                    this.pswdHidden.one = !this.pswdHidden.one
                } else {
                    this.pswdHidden.two = !this.pswdHidden.two
                }
            }
        },
        mounted() {
            let username = localStorage.getItem('setPswdLogin')
            if (username == null) {
                this.$router.push('/login')
            } else {
                this.username = username
                localStorage.removeItem('setPswdLogin')
            }
        },
        beforeDestroy() {
            localStorage.removeItem('setPswdLogin')
        }
    }
</script>

<style lang="scss">

    .form {
        fieldset {
            display: flex;
            flex-direction: column;
            align-items: center;
            span {
                display: block;
                max-width: 500px;
            }
        }
    }

    header.header-animation {
        position: relative;

        .top {
            position: absolute;
            padding: 20px 0;
            top: 0;
            left: 0;
            right: 0;

            .container {
                display: flex;
                justify-content: space-between;

                a {
                    color: #fff;
                    font: 400 15px/16px "Roboto", "Arial", sans-serif;
                }
            }
        }

        .lamp {
            position: absolute;
            height: 344px;
            width: 512px;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            top: 84px;
            background: transparent url("../../assets/img/lamp-login.png") no-repeat center center;
        }

        .text {
            position: absolute;
            width: 100%;
            left: 0;
            right: 0;
            top: 213px;
            background: rgba(1, 24, 38, .84);
            text-align: center;
            font: 700 37px/43px "Roboto", "Arial", sans-serif;
            text-transform: uppercase;
            letter-spacing: 4px;
            color: #fff;
        }
    }

    .particles {
        background-color: #021927;
        height: 480px;
        overflow: hidden;
        #particles-js {
            height: 480px;
        }
    }
    .gradient-login {
        background: #00ff97; /* Old browsers */
        background: -moz-linear-gradient(45deg,  #00ff97 0%, #0055ff 99%); /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ff97', endColorstr='#0055ff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
        background-color: #e4e5e6;
    }

    .contentpage {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #F8F8F8;
        padding: 14px 0 37px;
        text-align: center;

        h3 {
            display: block;
            margin-bottom: 13px;
            font: 700 20px/26px "Roboto", "Arial", sans-serif;
            color: #000;
        }

        h4 {
            display: block;
            max-width: 636px;
            margin-bottom: 20px;
            font: 400 14px/19px "Roboto", "Arial", sans-serif;
            color: #9F9F9F;
        }

        h5 {
            display: block;
            margin-bottom: 20px;
            font: 400 14px/19px "Roboto", "Arial", sans-serif;
            color: #000;
        }

        .form {
            fieldset {
                margin-bottom: 16px;
                .password-input-box {
                    display: flex;
                    align-items: center;
                    width: 240px;
                    .lock-box {
                        background-color: #f0f3f5;
                        border: 1px solid #E4E7EA;
                        border-right: 0;
                        border-radius: 5px 0 0 5px;
                        .fa-lock {
                            padding: 10px 14px;
                            font-size: 16px;
                            color: #5C6873;
                        }
                    }
                    .password-input {
                        padding: 7px 10px 6px 10px;
                        border-radius: 0 5px 5px 0;
                        border: 1px solid #C9CFD4;
                        background-color: #e4e5e6;
                        text-align: left;
                        input {
                            border: 0;
                            background-color: #e4e5e6;
                            &:focus {
                                outline: 0;
                            }
                        }
                        .fa {
                            margin-left: 10px;
                            cursor: pointer;
                        }
                    }
                    &.no-icon {
                        .password-input {
                            flex-grow: 1;
                        }
                    }
                    span {
                        display: block;
                    }
                }
                .validate-warning {
                    color: #FC4D4D;
                }
            }

            .btn-sumbit {
                height: 35px;
                padding: 0 25px;
                margin-top: 10px;
                background-color: #0088FF;
                border-radius: 5px;
                font: 400 14px/33px "Roboto", "Arial", sans-serif;
                color: #fff;
            }
        }

        a {
            font-size: 14px;
        }
    }

    footer {
        padding: 25px 0 100px;
        text-align: center;
    }
</style>
